"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interval = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("../../../utils/utils");
var StyledInterval = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  margin: 15px 8px;\n  height: 1px;\n  background: ", ";\n  &:before {\n    content: \"\";\n    position: absolute;\n    left: -8px;\n    height: 1px;\n    width: 8px;\n    background: ", ";\n  }\n  &:after {\n    content: \"\";\n    position: absolute;\n    right: -8px;\n    height: 1px;\n    width: 8px;\n    background: ", ";\n  }\n  > div {\n    position: absolute;\n    top: -3px;\n    height: 7px;\n    background: ", ";\n    width: ", ";\n    border-radius: ", "px;\n  }\n"], ["\n  position: relative;\n  margin: 15px 8px;\n  height: 1px;\n  background: ", ";\n  &:before {\n    content: \"\";\n    position: absolute;\n    left: -8px;\n    height: 1px;\n    width: 8px;\n    background: ", ";\n  }\n  &:after {\n    content: \"\";\n    position: absolute;\n    right: -8px;\n    height: 1px;\n    width: 8px;\n    background: ", ";\n  }\n  > div {\n    position: absolute;\n    top: -3px;\n    height: 7px;\n    background: ", ";\n    width: ", ";\n    border-radius: ", "px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.gray4, theme.gray3);
}, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.gray4, theme.gray3);
}, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.gray4, theme.gray3);
}, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__primaryColor, theme.primaryColor, theme.primaryColor);
}, function (_a) {
    var max = _a.max, current = _a.current;
    return "".concat((0, utils_1.calcPercentage)(current, max));
}, function (props) { return props.theme.buttonRadius; });
var Interval = function (props) {
    var _a;
    return ((0, jsx_runtime_1.jsx)(StyledInterval, __assign({}, props, { className: "wellms-component ".concat((_a = props.className) !== null && _a !== void 0 ? _a : "") }, { children: (0, jsx_runtime_1.jsx)("div", {}) })));
};
exports.Interval = Interval;
var templateObject_1;
